<template>
    <div>
        <!-- EXCEL -->
        <Dialog :visible.sync="dialogExcel" :closable="false" :containerStyle="{ width: '600px' }" :modal="true">
            <Card>
                <template #title>
                    <div class="p-d-flex p-fluid grid formgrid">
                        <div class="text-left field col-4">
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"
                                @click="cerraExcel()" />
                        </div>
                        <div class="text-center field col-4">
                            Cargar Excel
                        </div>
                        <div class="text-right field col-4">
                            <Button icon="pi pi-file-pdf"
                                class="ml-3 mr-1 p-button-rounded p-button-success p-button-outlined"
                                @click="cargarExcel" />
                        </div>
                    </div>
                    <hr size=7 color="#ED6421">
                </template>
                <template #content>
                    <FileUpload name="demo[]" :customUpload="true" @uploader="cargarExcel" accept=".csv, .xlsx"
                        :maxFileSize="5242880">
                        <template #empty>
                            <p>Arrastre y suelte para cargar</p>
                        </template>
                    </FileUpload>
                </template>
            </Card>
        </Dialog>

        <DataTable :value="listTrabajadores" :selection.sync="nomina.trabajadores" selectionMode="multiple" responsiveLayout="scroll" dataKey="rfc" :metaKeySelection="false" style="margin-top: 2em" :scrollable="true" scrollHeight="400px" scrollDirection="both" :filters.sync="filtros">
            <template #header>
                <div class="flex card-container blue-container overflow-hidden">
                    <div class="col-4 text-left ">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtros['global'].value" placeholder="Buscar" />
                        </span>
                    </div>
                    <div class="col-8 text-right">
                        <Button icon="pi pi-download" class="p-button-rounded p-button-outlined" @click="abrirExcel()" v-tooltip.bottom="'Seleccionar desde Excel'" style="color:#FBC31F"/>
                    </div>
                </div>
            </template>
            <Column field="numEmpleado" sortable header="Num. Empleado" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
            <Column field="nombre" sortable header="Nombre" :styles="{'flex-grow':'1', 'flex-basis':'250px'}"></Column>
            <Column field="rfc" sortable header="RFC" :styles="{'flex-grow':'1', 'flex-basis':'180px'}"></Column>
            <Column field="curp" sortable header="CURP" :styles="{'flex-grow':'1', 'flex-basis':'250px'}"></Column>
            <Column field="tipoRegimen.tipoRegimen" sortable header="Tipo de Régimen" :styles="{'flex-grow':'1', 'flex-basis':'250px'}"></Column>
            <!-- <Column field="puesto" sortable header="Puesto" :styles="{'flex-grow':'1', 'flex-basis':'150px'}"></Column> -->
            <!-- <Column field="departamento" sortable header="Departamento" :styles="{'flex-grow':'1', 'flex-basis':'150px'}"></Column> -->
            <Column field="empresa" sortable header="Empresa" :styles="{'flex-grow':'1', 'flex-basis':'100px'}"></Column>
        </DataTable>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";
    import readXlsFile from 'read-excel-file';

    export default {
        components: {

        },
        data() {
            return {
                selectedTrabajadores: [],
                filtros: {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                },
                dialogExcel: false,
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            nomina(){
                return this.$store.state.nominaStore;
            },

            listTrabajadores(){
                return this.$store.state.trabajadoresStore;
            },
        },
        created() {

        },
        methods: {
            //CARGA DESDE EXCEL
            abrirExcel() {
                this.dialogExcel = true;
            },

            cargarExcel(event) {
                this.nomina.trabajadores = [];
                try {
                    const file = event.files[0];
                    readXlsFile(file).then((rows) =>{
                        for(let i of rows){
                            console.log(i[0])
                            var t = this.listTrabajadores.find(o => o.rfc === i[0]);
                            console.log(t)
                            if(t ){
                                this.nomina.trabajadores.push(t);
                            }
                        }
                    })
                } catch (error) {
                    console.log(error)
                }
            },

            cerraExcel() {
                this.dialogExcel = false;
            },


        },
    }
    </script>